import { ButtonBaseLink, Snackbar, SnackbarContent, ThreeDSNotification } from '@razz-team/ui-web';
import { useMatch } from '@tanstack/react-router';
import { useActiveThreeDSList } from '../../api/3ds';

export function ThreeDSNotifications() {
  const match = useMatch({
    from: '/account/3ds_/$id_',
    shouldThrow: false,
  });

  const threeDSList = useActiveThreeDSList();
  const first = threeDSList[0];

  return (
    <Snackbar open={first && !match} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
      {first ? (
        <ButtonBaseLink to="/account/3ds/$id" params={{ id: first.id }} sx={{ display: 'block' }}>
          <SnackbarContent message={<ThreeDSNotification threeDS={first} />} />
        </ButtonBaseLink>
      ) : undefined}
    </Snackbar>
  );
}
